var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dg-notice",
      attrs: { id: "dgNotice" },
      on: { mouseenter: _vm.stopSwiper, mouseleave: _vm.moveSwiper },
    },
    [
      _c("img", {
        staticClass: "noticeImg",
        attrs: {
          width: "16px",
          height: "16px",
          src: require("../assets/images/notice.png"),
        },
      }),
      _vm._v(" "),
      _vm.noticeData.length
        ? _c(
            "swiper",
            {
              ref: "mySwiper",
              staticClass: "swiper-wrap",
              attrs: { id: "mySwiper1", options: _vm.swiperOption },
            },
            _vm._l(_vm.noticeData, function (item, index) {
              return _c(
                "swiper-slide",
                { key: index, staticClass: "swiperNotice" },
                [_c("span", [_vm._v(_vm._s(item.TITLE))])]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showContent
        ? _c("div", { staticClass: "showContent1" }, [
            _c("p", [_vm._v(_vm._s(_vm.noticeData[_vm.arrLen].BODY))]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }